<template>
  <cb-notification-bar
    variant="warning"
    test-id="user-not-connected-to-m365-warning-banner"
    :showCloseButton="false"
  >
    <template #title>
      {{ t("account-not-protected") }}
    </template>
    <template #description>
      {{ t("connect-m365-account") }}
    </template>
    <template #primaryCta v-if="!isOnConnectionPage">
      <cl-button
        variant="secondary"
        size="small"
        @on-click="goToConnectionPage"
      >
        {{ t("add-connection") }}
      </cl-button>
    </template>
  </cb-notification-bar>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useFlag } from "@/composables/useFlags/useFlag";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { isFeatureAvailable: isConnectionsV2Available } =
  useFlag("CONNECTIONS_V2");

const connectionPageName = computed(() =>
  isConnectionsV2Available.value
    ? "customer-settings-connections-v2"
    : "customer-settings-connections",
);

const isOnConnectionPage = computed<boolean>(() => {
  return route.name === connectionPageName.value;
});

const goToConnectionPage = (): void => {
  router.push({ name: connectionPageName.value });
};
</script>
